// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1nBYr","file":"styles_file__2DYT-"};